import React, {Component} from 'react';
import thumbshot1 from '../../assets/videoImgs/thumbshot1.jpg';
import api from '../../utils/api';
import AvatarEditor from 'react-avatar-editor';
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

/* global $, atob, Blob */

class ImageUpload extends Component {
    state = {
        imageFile: '',
        imagePreviewUrl: '',
        scale: 1
    };
    
    dataURItoBlob = (dataURI) => {
        var byteString = atob(dataURI.split(',')[1]);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: 'image/jpeg' });
    }

    //Actions
    handleImageChange = (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            this.setState({
                imageFile: file,
                imagePreviewUrl: reader.result
            });
        };
        file && reader.readAsDataURL(file);

        const data = new FormData();
        data.append('file', e.target.files[0], this.props.profileId + "-" + new Date().getTime().toString() + "-" + e.target.files[0].name);
        //this.props.onSave(data, this.props.user.id);
    };

    handleRemove = () => {
        this.setState({
            imageFile: '',
            imagePreviewUrl: thumbshot1
        });
    };

    //Renders
    renderImagePreview = (imagePreviewUrl) => {
        if (imagePreviewUrl) {
            
            return (
                
                <div className="fileinput-preview thumbnail">
                    <img src={imagePreviewUrl || thumbshot1}/>
                </div>
                
           
            );
        } else {
            return null
        }
    };

    renderFormInputs = (imagePreviewUrl) => (
        <div className="mar-top mar-btm">
            
            <span className="">
                {
                    !this.props.image.url &&
                    <div href={`${!this.props.thumbnail ? '#uploadBannerModal' : '#uploadThumbnailModal'}`} data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-plus" /> &nbsp; Add {this.props.thumbnail ? 'Thumbnail' : 'Banner'}</div>
                }
                {
                    this.props.image.url &&
                    <div href={`${!this.props.thumbnail ? '#uploadBannerModal' : '#uploadThumbnailModal'}`} data-toggle="modal" className="btn btn-default btn-block font-12"><i className="zmdi zmdi-edit" /> &nbsp; Replace {this.props.thumbnail ? 'Thumbnail' : 'Banner'}</div>
                    
                }
                
            </span>
            {
                imagePreviewUrl &&
                <span
                    className="btn red fileinput-exists"
                    onClick={this.handleRemove}
                >
                    Remove
                </span>
            }
        </div>
    );
    
    onClickSave = () => {
        if (this.editor) {
          // This returns a HTMLCanvasElement, it can be made into a data URL or a blob,
          // drawn on another canvas, or added to the DOM.

          // If you want the image resized to the canvas size (also a HTMLCanvasElement)
          const canvasScaled = this.editor.getImageScaledToCanvas()
          
          const canvas = this.editor.getImage().toDataURL("image/jpeg");
            let imageURL;
            const data = new FormData();
            data.append('file', this.dataURItoBlob(canvas), this.props.profileId + "-" + new Date().getTime().toString() + "-" + "img.jpeg");
            this.props.onSave(data, this.props.user.id);


        }
      }
    
      setEditorRef = (editor) => this.editor = editor
    
    get16By9 = (mode) => {
        let widths = [1920, 1280, 1024];
        let heights = [1080, 720, 576];
        
        let windowHeight = window.innerHeight;
        let windowWidth = window.innerWidth;
        
        let idealWidth = widths.filter(w => w < windowWidth);
        let idealHeight = heights.filter(h => h < windowHeight);
        
        if(idealWidth.length > 0){
            if(mode === "width"){
                return idealWidth[0];
            }else if(mode === "height"){
                let indexOfWidth = widths.indexOf(idealWidth[0]);
                return heights[indexOfWidth];
            }
        }

        
    }
    render() {
        let {imagePreviewUrl} = this.state;
        return (
            <div className="previewComponent">
                <div className="imgPreview video-img-preview">
                    {this.props.image.url && this.props.user ?
                        this.renderImagePreview(api.makeFileURL(this.props.image.url, this.props.user.id) || imagePreviewUrl)
                    :
                        this.renderImagePreview(imagePreviewUrl)}
                    
                </div>
                {this.renderFormInputs(imagePreviewUrl)}
                <div className="modal fade in" id={`${!this.props.thumbnail ? 'uploadBannerModal' : 'uploadThumbnailModal'}`} tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
                    <div className={`modal-dialog ${!this.props.thumbnail ? 'modal-xl' : ''}`} role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                                    <h4 className="modal-title" id="myModalLabel">{this.props.thumbnail ? 'Thumbnail' : 'Banner'}</h4>
                                </div>
                                <div className="modal-body no-padding">
                                    <div className="modal-body">
                                
                                    <div className="text-center">
                                        {this.state.imageFile &&
                                            <AvatarEditor
                                              ref={this.setEditorRef}
                                              image={imagePreviewUrl}
                                              width={!this.props.thumbnail ? this.get16By9("width") : 250}
                                              height={!this.props.thumbnail ? this.get16By9("height") : 250}
                                              border={50}
                                              scale={this.state.scale}
                                              style={{margin: 'auto'}}
                                            />
                                        }
                                        
                                        <div className="slide-container">
                                        {this.state.imageFile &&
                                            <Slider onChange={e => {
                                                this.setState({scale: e});
                                            }} value={this.state.scale} min={1} max={2} step={.1} />
                                        }
                                        </div>
                                        
                                        {!this.state.imageFile &&
                                            <div className="up-container">
                                                <button className="btn btn-default" onClick={e => {
                                                    e.preventDefault();
                                                    $(`#uploadImageButton-${!this.props.thumbnail}`).trigger('click');
                                                }}><i className="zmdi zmdi-image" /> &nbsp; Select Image</button>
                                                <input
                                                    className="videoThumbHiddenInput"
                                                    type="file"
                                                    id={`uploadImageButton-${!this.props.thumbnail}`}
                                                    accept="image/*"
                                                    onChange={this.handleImageChange}
                                                />
                                            </div>
                                        }
                                    </div>
                                    
                                </div>
                                
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                                {imagePreviewUrl &&
                                    <button type="button" className="btn btn-success" data-dismiss="modal" onClick={e => this.onClickSave()}>Save Image</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ImageUpload;


// WEBPACK FOOTER //
// ./src/components/EditChapterPart/ImgUpload.js